export const createEventEmitter = () => {
  const subscribers = [];

  const addSubscriber = (subscriber) => {
    subscribers.push(subscriber);
  };

  const removeSubscriber = (subscriber) => {
    const subscriberIndex = subscribers.indexOf(subscriber);
    if (subscriberIndex !== -1) {
      subscribers.splice(subscriberIndex, 1);
    }
  };

  const subscribe = (subscriber) => {
    if (typeof subscriber !== 'function') {
      throw new Error('Subscriber must provide a function');
    }

    addSubscriber(subscriber);

    return () => removeSubscriber(subscriber);
  };

  const emit = (...args) => {
    subscribers.forEach(sub => sub(...args));
  };

  return Object.freeze({
    subscribe,
    emit,
  });
};

export default {
  createEventEmitter,
};
